import * as yup from 'yup'

export const picValidation = yup.object().shape({
    companyId: yup.string().required('Harus diisi'),
    namaPIC: yup.string().required('Harus diisi'),
    jabatan: yup.string().required('Harus diisi'),
    email: yup.string().email('Email harus valid').required('Harus diisi'),
    telepon: yup.string().required('Harus diisi'),
    fax: yup.string().required('Harus diisi'),
}).required()